var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"copy-to-clipboard-trigger",on:{"click":_vm.handleClick}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"copy-to-clipboard-trigger__confirmation",attrs:{"data-confirmed":_vm.confirmed}},[(_vm.$slots.confirmation)?[_vm._t("confirmation")]:_c('span',[_vm._v("Copied!")])],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }